import React from "react";
import "../style/loading.css";

export default function Loading(prop) {
  if (prop?.state == "LoggingIn") {
    return <div>Logg inn i det nye popup-vinduet.</div>;
  } else {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
      </div>
    );
  }
}
